angular.module('iw.frontyard.repayment_calculator', [
    'iw.frontyard.app',
    'iw.frontyard.math',
    'iw.frontyard.translate',
    'iw.frontyard.string',
    'ui.slider',
]);
